import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

export const useSwitchSection = (section = 'about') => {
  const [state, setState] = useState(section);

  const [options, setOptions] = useState({
    about: false,
    comments: false,
    files: false,
  });

  useEffect(() => {
    if (state === 'about') {
      setOptions({ about: true, comments: false, files: false });
    } else if (state === 'comments') {
      setOptions({ about: false, comments: true, files: false });
    } else if (state === 'files') {
      setOptions({ about: false, comments: false, files: true });
    } else {
      setOptions({ about: false, comments: false, files: false });
    }
  }, [state]);

  return [options, setState];
};

function formatDate(dateString) {
  const date = DateTime.fromISO(dateString);
  const formattedDate = date.toFormat('dd/MM/yyyy hh:mm a');

  return `Criado em: "${formattedDate}"`;
}

function getDateUntilAt(dateString) {
  const date = DateTime.fromISO(dateString);
  const now = DateTime.now();

  const diff = now
    .diff(date, [
      'years',
      'months',
      'weeks',
      'days',
      'hours',
      'minutes',
      'seconds',
    ])
    .toObject();

  if (diff.years > 0) {
    return { untilAt: `${diff.years} year${diff.years > 1 ? 's' : ''}` };
  } else if (diff.months > 0) {
    return { untilAt: `${diff.months} month${diff.months > 1 ? 's' : ''}` };
  } else if (diff.weeks > 0) {
    return { untilAt: `${diff.weeks} week${diff.weeks > 1 ? 's' : ''}` };
  } else if (diff.days > 0) {
    return { untilAt: `${diff.days} day${diff.days > 1 ? 's' : ''}` };
  } else if (diff.hours > 0) {
    return { untilAt: `${diff.hours} hour${diff.hours > 1 ? 's' : ''}` };
  } else if (diff.minutes > 0) {
    return { untilAt: `${diff.minutes} minute${diff.minutes > 1 ? 's' : ''}` };
  } else {
    return { untilAt: `${diff.seconds} second${diff.seconds > 1 ? 's' : ''}` };
  }
}

export function classifyDataByDate(data) {
  const today = DateTime.local().startOf('day');
  const lastWeek = today.minus({ weeks: 1 });
  // const lastMonth = today.minus({ months: 1 });

  const classifiedData = {
    today: [],
    lastWeek: [],
    beforeLastWeek: [],
  };

  data.forEach((obj) => {
    const createdDate = DateTime.fromISO(obj.createdAt);

    if (createdDate >= today) {
      classifiedData.today.push({
        createdAt: formatDate(createdDate),
        message: obj.message,
        username: obj.username,
        avatarURL: obj.avatarURL,
        until: getDateUntilAt(createdDate).untilAt,
      });
    } else if (createdDate >= lastWeek) {
      classifiedData.lastWeek.push({
        createdAt: formatDate(createdDate),
        message: obj.message,
        username: obj.username,
        avatarURL: obj.avatarURL,
        until: getDateUntilAt(createdDate).untilAt,
      });
    } else {
      classifiedData.beforeLastWeek.push({
        createdAt: formatDate(createdDate),
        message: obj.message,
        username: obj.username,
        avatarURL: obj.avatarURL,
        until: getDateUntilAt(createdDate).untilAt,
      });
    }
  });

  return classifiedData;
}
